//get with or without country specific path
import { getCountrySpecificPath, getCountryIsoCode } from '../web/routes/Constants';

const getRoutePath = props => {
  const { path } = props;
  const countrySpecificPath = getCountrySpecificPath();
  const countryIsoCode = getCountryIsoCode();
  const updatedCountryIsoCode = countrySpecificPath ? '/' + countryIsoCode : '';
  return path.replace('/:country_iso_code', updatedCountryIsoCode);
}

export default getRoutePath;